import styled, { withTheme } from 'styled-components';
import ThemeSvg from '../../assets/images/theme-mode-icon.svg';

const ThemeIcon = styled.span`
  background: url(\"${ThemeSvg}\") no-repeat right center;
  background-size: 24px 24px;
  width: 100%;
  /* margin: 20px 0; */
  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
  }
`;

export default withTheme(ThemeIcon);
